import styled from 'styled-components'
import PropTypes from 'prop-types'

const Label = styled.label`
        color: ${props => props.color ? props.color : 'black'};
    `

Label.propTypes = {
    color: PropTypes.string,
}

export default Label



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Atoms/Label.jsx